import { render, staticRenderFns } from "./DocumentWithSectionsNewOrEdit.vue?vue&type=template&id=4493950a&scoped=true&"
import script from "./DocumentWithSectionsNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentWithSectionsNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentWithSectionsNewOrEdit.vue?vue&type=style&index=0&id=4493950a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493950a",
  null
  
)

export default component.exports